import { Condiment, CondimentGroup, CondimentGroupString, CondimentString, ResultSetHeader } from './../../models';
import http, { HttpSuccessOrErrorType } from '../http';

export default {
    /**
     * 创建调味品组
     * @param params 参数
     */
    async create_condiment_group(params: CondimentGroup & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.post(`/restaurant/${string_id}/condiment_group`, {
            ...rest
        })
    },

    /**
     * 创建调味品
     * @param params 参数
     */
    async create_condiment(params: Condiment & { string_id: string, cgid: number }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, cgid, ...rest } = params;
        return await http.post(`/restaurant/${string_id}/condiment_group/${cgid}/condiment`, {
            ...rest
        })
    },

    /**
     * 调味品组动态国际化
     * @param params 参数
     */
    async condiment_group_strings(params: { string_id: string, request: CondimentGroupString[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, request } = params;
        return await http.post(`/restaurant/${string_id}/condiment_group/condiment_group_strings`, request)
    },

    /**
     * 调味品动态国际化
     * @param params 参数
     */
    async condiment_strings(params: { string_id: string, request: CondimentString[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, request } = params;
        return await http.post(`/restaurant/${string_id}/condiment/condiment_strings`, request)
    },

    /**
     * 根据调味品组名称模糊查询调味品组
     * @param params 参数
     */
    async get_condiment_groups_by_name(params: { string_id: string, name: string }): Promise<HttpSuccessOrErrorType<CondimentGroup[]>> {
        const { string_id, name } = params;
        return await http.get(`/restaurant/${string_id}/condiment_groups/name`, {
            params: {
                name
            }
        })
    },

    /**
     * 根据id获取调味品组信息
     * @param params 参数
     */
    async get_condiment_group_id(params: { string_id: string, id: string }): Promise<HttpSuccessOrErrorType<CondimentGroup>> {
        const { string_id, id } = params;
        return await http.get(`/restaurant/${string_id}/condiment_group/${id}`)
    },

    /**
     * 编辑调味品组
     * @param params 参数
     */
    async patch_condiment_group(params: CondimentGroup & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/condiment_group/${id}`, {
            ...rest
        })
    },

    /**
     * 创建调味品
     * @param params 参数
     */
    async patch_condiment(params: Condiment & { string_id: string, cgid: number }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id, cgid, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/condiment_group/${cgid}/condiment/${id}`, {
            ...rest
        })
    },

    /**
     * 批量删除调味品组
     * @param params 参数
     */
    async delete_condiment_groups(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/condiment_groups`, {
            params: {
                is_mandatory: '1'
            },
            data: {
                ids
            }
        })
    },

    /**
     * 批量删除调味品
     * @param params 参数
     */
    async delete_condiments(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/condiments`, {
            params: {
                is_mandatory: '1'
            },
            data: {
                ids
            }
        })
    },

    /**
     * 批量删除调味品组动态国际化数据
     * @param params 参数
     */
    async delete_condiment_group_strings(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/condiment/condiment_group_strings`, {
            data: {
                ids
            }
        })
    },

    /**
     * 批量删除调味品动态国际化数据
     * @param params 参数
     */
    async delete_condiment_strings(params: { string_id: string, ids: Array<number> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/condiment/condiment_strings`, {
            data: {
                ids
            }
        })
    }

}